import { useAppSelector } from "app/hooks";
import { BMultiSelect } from "components";
import { selectMemberRoles } from "features/admin/members/Members.slice";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface MemberRolesMultiSelectProps {
  required?: boolean;
  onChange?: (value: string[] | undefined) => void;
  error?: ReactNode;
  value?: string[]; // could be undefined if form has no initial values
  disabled?: boolean;
}

export const MemberRolesMultiSelect = (props: MemberRolesMultiSelectProps) => {
  const { t } = useTranslation();
  const memberRoles = useAppSelector(selectMemberRoles);
  const data = memberRoles.map((o) => ({ value: o.id, label: o.name }));

  return (
    <BMultiSelect
      {...props}
      label={t("ROLES")}
      nothingFound={t("NOTHING_FOUND")}
      data={data}
    />
  );
};
